import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, Auth } from "firebase/auth";

// Temporary configuration - will be replaced when we set up Firebase project
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "demo-api-key",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "demo.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "demo-project",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "demo.appspot.com",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "demo-app-id",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-XXXXXXXXXX",
};

let app;
let auth: Auth | null = null;

// Only initialize Firebase if we have real config (not demo values)
if (
  typeof window !== "undefined" &&
  import.meta.env.VITE_FIREBASE_API_KEY &&
  import.meta.env.VITE_FIREBASE_API_KEY !== "demo-api-key"
) {
  try {
    app = app || initializeApp(firebaseConfig);
    auth = getAuth(app);
  } catch (error) {
    // Firebase initialization failed - could add proper error handling here
  }
} else {
  // Firebase not initialized in demo mode
}

export { auth, onAuthStateChanged };
